document.addEventListener('DOMContentLoaded', function() {

  const $accordions = jQuery('.block-accordion');
  if( $accordions.length == 0 ) return;

  $accordions.find('.accordion-title').on('click', function(e) {
    e.preventDefault();
    jQuery(this)
      .toggleClass('open')
      .next()
      .slideToggle(150);
  });

});